import React, { useEffect } from 'react';

const GoogleTranslateFix = () => {
  useEffect(() => {
    // 1. Inject "Nuclear" CSS to hide every part of the Google Bar
    const style = document.createElement('style');
    style.id = 'google-translate-fix-style';
    style.innerHTML = `
      /* Hide the top 'iframe' banner (Legacy) */
      .goog-te-banner-frame.skiptranslate { display: none !important; } 
      iframe.goog-te-banner-frame { display: none !important; }
      
      /* 🟢 HIDE THE SPECIFIC DIV FROM YOUR SCREENSHOT */
      body > .skiptranslate { display: none !important; } 
      .skiptranslate { display: none !important; }
      
      /* Force Body to the top (Overrides Google's inline styles) */
      body { 
        top: 0px !important; 
        position: static !important; 
      } 
      
      /* Hide tooltips and hover effects */
      .goog-tooltip { display: none !important; }
      .goog-tooltip:hover { display: none !important; }
      .goog-text-highlight { background-color: transparent !important; border: none !important; box-shadow: none !important; }
      
      /* Hide the element itself if visible */
      #google_translate_element { display: none !important; } 
    `;
    
    // Prevent duplicate style tags
    if (!document.getElementById('google-translate-fix-style')) {
        document.head.appendChild(style);
    }

    // 2. The "Enforcer" (Watches the DOM 5 times a second)
    const intervalId = setInterval(() => {
        // A. Force Body to top
        if (document.body.style.top && document.body.style.top !== "0px") {
            document.body.style.top = "0px";
            document.body.style.position = "static";
        }
        
        // B. Hunt down the banner and hide it manually
        const banner = document.querySelector('.goog-te-banner-frame');
        if (banner) banner.style.display = 'none';

        // C. Hunt down the skiptranslate div (The one in your image)
        // We look for a skiptranslate div that is a direct child of body
        const skipDiv = document.querySelector('body > .skiptranslate');
        if (skipDiv) {
             skipDiv.style.display = 'none';
        }
    }, 200); // Check fast enough that the user never sees it

    // Cleanup
    return () => clearInterval(intervalId);
  }, []);

  return null; // Invisible component
};

export default GoogleTranslateFix;